export const END_POINT = {
   CONNECT_PAGE: '/SocialApi/page/facebook/connect-page',
   CURRENT_PAGE: '/SocialApi/page/facebook/current-page',
   LAST_PAGE: '/SocialApi/page/facebook/last-page',
   LIST_CAMPAIGNS: '/SocialApi/page/facebook/list-campaigns',
   LIST_PAGES: '/SocialApi/page/facebook/list-pages',
   LIST_POST: '/SocialApi/page/facebook/list-posts',
   LIST_PAGES_CONNECTED: '/SocialApi/page/facebook/list-pages-connected',
   STOP_CONNECT_PAGE: '/SocialApi/page/facebook/stop-connect-page',
   PAGE_SETTING_INFO: '/SocialApi/page/facebook/page-settings-info',
   PAGE_SETTING: '/SocialApi/page/facebook/page-settings',
   PAGE_CAMPAIGNS: '/SocialApi/page/facebook/page-campaigns',
   ADD_CAMPAIGN_PRODUCT: '/SocialApi/page/facebook/add-campaign-product',
   UPDATE_CAMPAIGN_PRODUCT: '/SocialApi/page/facebook/update-campaign-product',
   DELETE_CAMPAIGN_PRODUCT: '/SocialApi/page/facebook/delete-campaign-product',
   LIST_PRODUCTS_CAMPAIGN: '/SocialApi/page/facebook/list-products-campaign',
   ADD_POSTS_CAMPAIGN: '/SocialApi/page/facebook/add-posts-campaign',
   LIST_POSTS_CAMPAIGN: '/SocialApi/page/facebook/list-posts-campaign',
   DELETE_POST_CAMPAIGN: '/SocialApi/page/facebook/delete-post-campaign',
   POST_ON_FEED: '/SocialApi/page/facebook/post-on-feed',
   PAGE_CAMPAIGN_DETAILS: '/SocialApi/page/facebook/page-campaign-details',
   LIST_PRODUCTS_WAREHOUSE: '/SocialApi/page/facebook/list-products-warehouse',
   COMMENT_POSTS: '/SocialApi/page/facebook/comment-posts',
   SHOPPING_CARTS: '/SocialApi/sales/shopping-carts',
   SHOPPING_CART_SUBMIT: '/SocialApi/sales/shopping-cart-submit',
   PROVINCES: '/SocialApi/sales/provinces',
   DISTRICTS: '/SocialApi/sales/districts',
   WARDS: '/SocialApi/sales/wards',
   SHOPPING_CART_ITEMS: '/SocialApi/sales/shopping-cart-items',
   ORDER_INFO: '/SocialApi/sales/order/info',
   LIST_PAYMENT_METHOD: '/SocialApi/sales/list-payment-method',
   PAYMENT_SUBMIT: '/SocialApi/sales/payment-submit',
   LOGIN_TICKET: '/minigame/oauth/loginTicket/v6',
   LOGOUT_TICKET: '/minigame/oauth/logout',
   LIST_COMMENTS_POST: '/SocialApi/page/facebook/list-comments-post',
   DELETE_COMMENT_POST: '/SocialApi/page/facebook/delete-comment-post',
   LIST_REELS: '/SocialApi/page/facebook/list-reels',
   ICE_BREAKER: '/SocialApi/chat/assistant/ice_breaker',
   ACTIVE_ICEBREAKERS: '/SocialApi/chat/assistant/active-icebreakers',
   ICE_BREAKER_ITEMS: '/SocialApi/chat/assistant/ice_breaker_items',
   PAGE_GREETINGS: '/SocialApi/page/facebook/page-greetings',
   GREETINGS: '/SocialApi/page/facebook/greetings',
   WELCOME_MESSAGE: '/SocialApi/chat/assistant/welcome-message',
   ACTIVE_WELCOME_MESSAGE: '/SocialApi/chat/assistant/active-welcome-message',
   WELCOME_MESSAGE_ITEM: '/SocialApi/chat/assistant/welcome-message-item',
   PERSISTENT_MENU: '/SocialApi/chat/assistant/persistent_menu',
   ACTIVE_MENU: '/SocialApi/chat/assistant/active-menu',
   PERSISTENT_MENU_ITEM: '/SocialApi/chat/assistant/persistent_menu_item',
   UPLOAD_MEDIA: '/SocialApi/upload/upload-media',
   FB_ATTACHMENT: '/SocialApi/upload/fb-attachment',
   LIVE_VIDEOS: '/SocialApi/livestream/posts/live-videos',
   POSTS_LIVE: '/SocialApi/livestream/posts-live',
   START_LIVE: '/SocialApi/livestream/start_live',
   LIVE_COMPLETE: '/SocialApi/livestream/complete',
   CUSTOMERS: '/SocialApi/orders/customers',
   CONVERSATIONS_CAMPAIGN: '/SocialApi/orders/conversations-campaign',
   LIVE_STREAM_BY_URL: '/SocialApi/livestream/posts/live_stream_by_url',
   LOAD_COMMENTS_CUSTOMER: '/SocialApi/orders/load-comments-customer',
   ORDER_HANDLING_STATUS: '/SocialApi/orders/order_handling_status',
   ORDER_HANDLE: '/SocialApi/orders/order_handle',
   GET_ALL_CAMPAIGN: '/SocialApi/orders/get_all_campaign',
   GET_ALL_INBOX: '/SocialApi/inbox/facebook/get-all-inbox',
   LOAD_ALL_DATA: 'SocialApi/inbox/facebook/load-all-data',
   GET_INBOX: '/SocialApi/inbox/facebook/get-inbox',
   SEARCH_INBOX: '/SocialApi/inbox/facebook/search-inbox',
   SEND_MESSAGE: '/SocialApi/inbox/facebook/send-message',
   REPLY_COMMENT: '/SocialApi/inbox/facebook/reply-comment',
   EDIT_COMMENT: '/SocialApi/inbox/facebook/edit-comment',
   HIDE_COMMENT: '/SocialApi/inbox/facebook/hide-comment',
   DELETE_COMMENT: '/SocialApi/inbox/facebook/delete-comment',
   SET_STATUS: '/SocialApi/inbox/facebook/set-status',
   AUDIENCES: '/SocialApi/user/audiences',
   CREATE_DRAFT: '/SocialApi/orders/create-draft',
   ORDERS_CHECKOUT: '/SocialApi/orders/checkout',
   LIST_WARE_HOUSE: '/SocialApi/orders/list-ware-house',
   ORDER_LIST_PRODUCTS_WAREHOUSE: '/SocialApi/orders/list-products-warehouse',
   CREATE_CART: 'SocialApi/orders/create-cart',
   PURCHASE_HISTORY: '/SocialApi/orders/purchase/history',
   ORDER_CANCEL: '/SocialApi/orders/cancel',
   SEND_MESSAGE_ORDER: '/SocialApi/orders/send-message-order',
   GET_LIST_CONNECTED_TRANS_BY_SHOP: '/SocialApi/transport/getListConnectedTransByShop',
   GET_SERVICE_GHN: '/SocialApi/ghn/getService',
   GET_SERVICE_VTPOST: '/SocialApi/vtpost/getService',
   CALCULATE_FEE_GHN: '/SocialApi/ghn/calculateFee',
   CALCULATE_FEE_VTPOST: '/SocialApi/vtpost/calculateFee',
   CREATE_ORDER_GHN: '/SocialApi/ghn/createOrder',
   CREATE_ORDER_VTPOST: '/SocialApi/vtpost/createOrder',
   AFTER_START_LIVE: '/SocialApi/after/livestream/start_live',
   CRAWL_STATUS: '/SocialApi/after/livestream/crawl_status',
   CONVERSATIONS_POSTS: '/SocialApi/after/livestream/conversations-posts',
   ADD_TO_CART: '/SocialApi/after/livestream/add_to_cart',
   START_CRAWL_COMMENT: '/SocialApi/after/livestream/start_crawl_comment',
   STOP_CRAWL_COMMENT: '/SocialApi/after/livestream/stop_crawl_comment',
   AFTER_LIVE_COMPLETE: '/SocialApi/after/livestream/complete',
   PAYMENT_PAY_URL: '/SocialApi/payment/pay-url',
}

export const FACEBOOK_USER_TYPE = {
   SET: 'SET_FACEBOOK_USER'
}

export const PAGE_FACEBOOK_TYPE = {
   FETCH: 'FETCH_PAGE_FACEBOOKS'
}

export const PAGE_TYPE = {
   FETCH: 'FETCH_PAGES',
   SELECT: 'SELECT_PAGE'
}

export const ERROR_TYPE = {
   SET: 'SET_ERROR',
   CLEAR: 'CLEAR_ERROR'
}

export const LOADING_TYPE = {
   SHOW: 'SHOW',
   HIDE: 'HIDE'
}

export const BUTTON_LOADING_TYPE = {
   SHOW: 'BUTTON_LOADING_SHOW',
   HIDE: 'BUTTON_LOADING_HIDE'
}

export const SUB_MENU_TYPE = {
   SET: 'SET_SUB_MENU'
}

export const SETTING_PAGE_TYPE = {
   FETCH: 'FETCH_METHOD_SETTING_PAGE',
   SET_METHOD: 'SET_METHOD_SETTING_PAGE',
   SET_TYPE_COMMENT: 'SET_TYPE_COMMENT_SETTING_PAGE',
   SET_MESSAGE_ADD_CART: 'SET_MESSAGE_ADD_CART_SETTING_PAGE',
   SET_BUTTON_ADD_CART: 'SET_BUTTON_ADD_CART_SETTING_PAGE',
   SET_MESSAGE_CONFIRM_CART: 'SET_MESSAGE_CONFIRM_CART_PAGE',
   SET_BUTTON_VIEW_CART: 'SET_BUTTON_VIEW_CART_PAGE',
   SET_CONTENT_MESSAGE_OUT_OF_STOCK: 'SET_CONTENT_MESSAGE_OUT_OF_STOCK_PAGE',
   SET_MESSAGE_GUIDE: 'SET_MESSAGE_GUIDE_PAGE',
   SET_IS_BUYING_GUIDE: 'SET_IS_BUYING_GUIDE_PAGE',
   SET_HAS_MESSAGE_OUT_OF_STOCK: 'SET_HAS_MESSAGE_OUT_OF_STOCK',
   SET_LIMIT_COMMENT_POST: 'SET_LIMIT_COMMENT_POST',
   SET_IS_REPLY_COMMENT: 'SET_IS_REPLY_COMMENT',
   SET_MESSAGE_COMMENT_ORDER: 'SET_MESSAGE_COMMENT_ORDER',
   SET_HAS_ADD_PRODUCT_TO_DRAFT_ORDERS: 'SET_HAS_ADD_PRODUCT_TO_DRAFT_ORDERS',
   SET_HAS_PRIVATE_REPLY_ADDRESS: 'SET_HAS_PRIVATE_REPLY_ADDRESS',
   SET_HAS_ASK_PHONE_NUMBER: 'SET_HAS_ASK_PHONE_NUMBER',
   SET_HAS_COMMENT_WELCOME_START_LIVE: 'SET_HAS_COMMENT_WELCOME_START_LIVE',
   SET_CONTENT_COMMENT_WELCOME_START_LIVE: 'SET_CONTENT_COMMENT_WELCOME_START_LIVE',
   SET_HAS_COMMENT_INTRO_PRODUCT: 'SET_HAS_COMMENT_INTRO_PRODUCT',
   SET_CONTENT_COMMENT_INTRO_PRODUCT: 'SET_CONTENT_COMMENT_INTRO_PRODUCT',
   SET_AUTO_COMPLETE_LIVE_CAMPAIGN: 'SET_AUTO_COMPLETE_LIVE_CAMPAIGN',
   SET_HAS_LOCK_COMMENT_CLOSE_SALE: 'SET_HAS_LOCK_COMMENT_CLOSE_SALE',
   SET_IS_NOT_INCREASE_QUANTITY_CART_ITEM: 'SET_IS_NOT_INCREASE_QUANTITY_CART_ITEM',
   SET_HAS_ORDER_TIME_CHECKOUT: 'SET_HAS_ORDER_TIME_CHECKOUT',
   SET_ORDER_TIME_CHECKOUT_TYPE: 'SET_ORDER_TIME_CHECKOUT_TYPE',
   SET_LIMIT_TIME_ORDER_CHECKOUT: 'SET_LIMIT_TIME_ORDER_CHECKOUT',
   SET_HAS_REMINDER_CHECKOUT: 'SET_HAS_REMINDER_CHECKOUT',
   SET_CONTENT_REMINDER_CHECKOUT: 'SET_CONTENT_REMINDER_CHECKOUT',
   SET_REMINDER_CHECKOUT_TIMES: 'SET_REMINDER_CHECKOUT_TIMES',
   SET_BUTTON_REMINDER_CHECKOUT: 'SET_BUTTON_REMINDER_CHECKOUT',
}

export const CAMPAIGN_TYPE = {
   FETCH: 'FETCH_CAMPAIGN',
   FETCHS: 'FETCH_CAMPAIGNS',
   CREATE: 'CREATE_CAMPAIGN',
   UPDATE: 'UPDATE_CAMPAIGN',
   ADD_POSTS: 'ADD_POSTS_CAMPAIGN',
   POSTS: 'FETCH_POST_CAMPAIGN',
   DELETE_POSTS: 'DELETE_POST_CAMPAIGN',
   ADD_PRODUCTS: 'ADD_PRODUCTS_CAMPAIGN',
   DELETE_PRODUCTS: 'DELETE_PRODUCTS_CAMPAIGN',
   UPDATE_PRODUCT: 'UPDATE_PRODUCT_CAMPAIGN',
   ADD_CAMPAIGNS: 'ADD_LIST_CAMPAIGNS',
}

export const POST_TYPE = {
   FETCH: 'FETCH_POST'
}

export const PRODUCT_TYPE = {
   FETCHS: 'FETCH_PRODUCTS'
}

export const CART_TYPE = {
   FETCH: 'FETCH_CART',
   CHANGE_QUANTITY: 'CHANGE_QUANTITY_CART',
   CHANGE_VALUE: 'CHANGE_VALUE_CART'
}

export const ADDRESS_TYPE = {
   PROVINCES: 'PROVINCES_ADDRESS',
   DISTRICTS: 'DISTRICTS_ADDRESS',
   WARDS: 'WARDS_ADDRESS',
}

export const ORDER_TYPE = {
   FETCH: 'FETCH_ORDER'
}

export const PAYMENT_TYPE = {
   FETCH: 'PAYMENT_ORDER'
}

export const USER_TYPE = {
   LOGIN: 'LOGIN_USER',
   LOGOUT: 'LOGOUT_USER',
}

export const COMMENT_POST_TYPE = {
   FETCH: 'FETCH_COMMENT_POST',
   DELETE: 'DELETE_COMMENT_POST'
}

export const FAQ_TYPE = {
   FETCH: 'FETCH_FAQ',
   FETCHS: 'FETCHS_FAQ',
   ADD: 'ADD_FAQ',
   DELETE: 'DELETE_FAQ',
   UPDATE_ACTIVE: 'UPDATE_ACTIVE_FAQ',
   DELETE_NOT_ACTIVE: 'DELETE_NOT_ACTIVE_FAQ',
   ON_CHANGE: 'ON_CHANGE',
   UPDATE_NAME: 'UPDATE_NAME_FAQ'
}

export const GLOBAL_TYPE = {
   LOGIN_EXPIRED: 'LOGIN_EXPIRED'
}

export const MESSAGE_SETTING_GENERAL_TYPE = {
   FETCH: 'MESSAGE_SETTING_GENERAL_FETCH',
   ON_CHANGE_TEXT: 'ON_CHANGE_TEXT_MESSAGE_SETTING_GENERAL',
   ON_CHANGE_ACTIVE: 'ON_CHANGE_ACTIVE_MESSAGE_SETTING_GENERAL',
   UPDATE: 'MESSAGE_SETTING_GENERAL_UPDATE'
}

export const SETTING_WELCOME_MESSAGE_TYPE = {
   FETCH: 'SETTING_WELCOME_MESSAGE_FETCH',
   ON_CHANGE_ACTIVE: 'ON_CHANGE_ACTIVE_SETTING_WELCOME_MESSAGE',
}

export const SETTING_MAIN_MENU_TYPE = {
   FETCH: 'SETTING_MAIN_MENU_FETCH',
   ON_CHANGE_ACTIVE: 'ON_CHANGE_ACTIVE_SETTING_MAIN_MENU',
}

export const MODAL_TYPE = {
   OPEN: 'OPEN_MODAL_TYPE',
   CLOSE: 'CLOSE_MODAL_TYPE'
}

export const LIVE_CAMPAIGN_TYPE = {
   FETCHS: 'FETCHS_LIVE_CAMPAIGN',
   DELETE: 'DELETE_LIVE_CAMPAIGN'
}

export const POST_LIVE_TYPE = {
   FETCHS: 'FETCHS_POST_LIVE'
}

export const COMMENT_TYPE = {
   FETCHS: 'FETCHS_COMMENT',
   FETCHS_MORE: 'FETCHS_MORE_COMMENT',
   ADD: 'ADD_COMMENT'
}

export const CUSTOMER_TYPE = {
   FETCHS: 'FETCHS_CUSTOMER',
   LOAD_COMMENTS: 'LOAD_COMMENTS_CUSTOMER',
   LOAD_SHOW_MORE_COMMENTS: 'LOAD_SHOW_MORE_COMMENTS_CUSTOMER',
   ORDER_HANDLING_STATUS: 'ORDER_HANDLING_STATUS_CUSTOMER',
   ORDER_HANDLE: 'ORDER_HANDLE_CUSTOMER'
}

export const CONVERSATION_TYPE = {
   GET_ALL_INBOX: 'GET_ALL_INBOX_CONVERSATION',
   GET_MORE_ALL_INBOX: 'GET_MORE_ALL_INBOX_CONVERSATION',
   LOAD_ALL_DATA: 'LOAD_ALL_DATA_CONVERSATION',
   GET_INBOX: 'GET_INBOX_CONVERSATION',
   GET_MORE_INBOX: 'GET_MORE_INBOX_CONVERSATION',
   SEARCH_INBOX: 'SEARCH_INBOX_CONVERSATION',
   SEND_MESSAGE: 'SEND_MESSAGE_CONVERSATION',
   TEMP_MESSAGE: 'TEMP_MESSAGE_CONVERSATION',
   REPLY_COMMENT: 'REPLY_COMMENT_CONVERSATION',
   EDIT_COMMENT: 'EDIT_COMMENT_CONVERSATION',
   HIDE_COMMENT: 'HIDE_COMMENT_CONVERSATION',
   DELETE_COMMENT: 'DELETE_COMMENT_CONVERSATION',
   SET_STATUS: 'SET_STATUS_CONVERSATION',
   SET_FILTER: 'SET_FILTER_CONVERSATION',
   RESET_FILTER: 'RESET_FILTER_CONVERSATION',
   MESSAGE_SOCKET: 'MESSAGE_SOCKET_CONVERSATION',
   CREATE_DRAFT: 'CREATE_DRAFT_CONVERSATION',
   ORDERS_CHECKOUT: 'ORDERS_CHECKOUT_CONVERSATION',
   CLEAR_DRAFT: 'CLEAR_DRAFT_CONVERSATION',
   PURCHASE_HISTORY: 'PURCHASE_HISTORY_CONVERSATION',
   ORDER_CANCEL: 'ORDER_CANCEL_CONVERSATION',
   GET_LIST_CONNECTED_TRANS_BY_SHOP: 'GET_LIST_CONNECTED_TRANS_BY_SHOP_CONVERSATION',
   GET_SERVICE: 'GET_SERVICE_CONVERSATION',
   CALCULATE_FEE: 'CALCULATE_FEE_GHN_CONVERSATION',
}

export const GENERAL_SETTING_TYPE = {
   SHOW_OR_HIDE_MENU: 'SHOW_OR_HIDE_MENU_GENERAL_SETTING',
   SHOW_OR_HIDE_INFO_CHAT: 'SHOW_OR_HIDE_INFO_CHAT_GENERAL_SETTING'
}

export const AUDIENCES_TYPE = {
   FETCH: "FETCH_AUDIENCES",
   GET: "GET_AUDIENCES",
}

export const WAREHOUSE_TYPE = {
   FETCHS: "FETCHS_WAREHOUSE_TYPE"
}